import call from './call';
import {push} from 'connected-react-router';
import {SHOW_MSG} from "../types";
import languages from "../language/languages";

export default (form) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result)
        {
            if(result[1].success)
            {
                dispatch(push('/'));
                dispatch({type: SHOW_MSG, payload: {message: languages[getState().auth.language].mailSent.concat(form.mail),type:'success'}});
            }
        }
    }
    dispatch(call("UserService/forgotPassword",form,onResult));
};